import {
  Component,
  Input,
  Output,
  EventEmitter,
  CUSTOM_ELEMENTS_SCHEMA,
} from '@angular/core';
import type { LeafSwitch } from '@cigna/leaf-web/lib/wc';
import '@cigna/leaf-web/lib/wc/components/switch/switch';

@Component({
  selector: 'cigna-leaf-switch',
  template: `
    <leaf-switch
      [checked]="checked"
      [disabled]="disabled || undefined"
      [label]="label"
      [showStatusLabel]="showStatusLabel"
    ></leaf-switch>
  `,
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CignaLeafSwitchComponent {
  // weird bug with fieldId where it does not autogenerate id if we pass undefined to input
  // so for now removing property. in  most cases you don't need to set explicit fieldId
  // @Input() fieldId: LeafSwitch['fieldId'] = undefined;
  @Input() label: LeafSwitch['label'];
  @Input() checked: LeafSwitch['checked'] = false;
  @Input() disabled: LeafSwitch['disabled'] = false;
  @Input() showStatusLabel: LeafSwitch['showStatusLabel'] = true;
}
